import { createStore } from 'redux';
import  tourReducer from './tourReducer';

function create_store (){
    return createStore(tourReducer);
}
export default create_store;